import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import styles from './Publications.module.css';

const handleComingSoon = () => {
  alert('Coming Soon! Paper submission will be available shortly.');
};

// Sample data – replace with actual data from backend
const journalIssues = [
  { id: 1, volume: 'Vol. 5 No. 2', title: 'Special Issue on Infectious Diseases', date: 'December 2024', abstract: 'Articles on malaria, tuberculosis, and emerging infections.' },
  { id: 2, volume: 'Vol. 5 No. 1', title: 'Maternal and Child Health', date: 'June 2024', abstract: 'Research on improving outcomes in Idoma communities.' },
  { id: 3, volume: 'Vol. 4 No. 2', title: 'Non-Communicable Diseases', date: 'December 2023', abstract: 'Focus on hypertension, diabetes, and cancer prevention.' },
];

const newsletters = [
  { id: 1, title: 'IMDF Quarterly Newsletter', date: 'Q1 2025', description: 'Highlights from the AGM, upcoming outreach, and member news.' },
  { id: 2, title: 'IMDF Quarterly Newsletter', date: 'Q4 2024', description: 'Year-end review and journal publication announcement.' },
  { id: 3, title: 'IMDF Quarterly Newsletter', date: 'Q3 2024', description: 'Medical outreach report and new trustee profiles.' },
];

const Publications = () => {
  return (
    <div className={styles.publications}>
      {/* Header – full width (negative margins) */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Publications</h1>
        <p className={styles.pageSubtitle}>Sharing knowledge, advancing health</p>
      </section>

      {/* Journal Section – contained */}
      <section className={styles.section}>
        <SectionTitle
          title="Journal of Medical Research and Practice"
          subtitle="Peer‑reviewed scholarly publication"
        />
        <div className={styles.journalIntro}>
          <p>
            The <strong>Journal of Medical Research and Practice</strong> is the flagship publication of IMDF. It publishes contemporary issues that advance health, development, and peaceful coexistence. The journal is managed by an independent Editorial Board and welcomes contributions from researchers and practitioners.
          </p>
          <div className={styles.journalButtons}>
            <Button variant="primary" size="medium" onClick={handleComingSoon}>Submit a Paper</Button>
            <Button variant="outline" size="medium" onClick={handleComingSoon}>Guide for Authors</Button>
          </div>
        </div>

        <SectionTitle title="Recent Issues" subtitle="Latest publications" align="center" />
        <div className={styles.cardGrid}>
          {journalIssues.map(issue => (
            <Card key={issue.id} variant="elevated" className={styles.issueCard}>
              <h3 className={styles.issueTitle}>{issue.volume}</h3>
              <p className={styles.issueSubtitle}>{issue.title}</p>
              <p className={styles.issueDate}>{issue.date}</p>
              <p className={styles.issueAbstract}>{issue.abstract}</p>
              {/* <Link to={`/publications/journal/${issue.id}`} className={styles.readMore}>
            Read More →
          </Link> */}
            </Card>
          ))}
        </div>
        <div className={styles.centered}>
          <Button variant="outline" size="medium" onClick={handleComingSoon}>View All Issues</Button>
        </div>
      </section>

      {/* Newsletter Section – contained */}
      <section className={styles.section}>
        <SectionTitle
          title="IMDF Newsletter"
          subtitle="Stay updated with Foundation activities"
          align="center"
        />
        <p className={styles.newsletterIntro}>
          The newsletter, edited by the Publicity Secretary, publishes activities, projects, and important information for members and the public.
        </p>

        <div className={styles.cardGrid}>
          {newsletters.map(item => (
            <Card key={item.id} variant="default" className={styles.newsletterCard}>
              <h3 className={styles.newsletterTitle}>{item.title}</h3>
              <p className={styles.newsletterDate}>{item.date}</p>
              <p className={styles.newsletterDesc}>{item.description}</p>
              <Link to="#" onClick={handleComingSoon} className={styles.downloadLink}>
                Download PDF →
              </Link>
            </Card>
          ))}
        </div>
        <div className={styles.centered}>
          <Button variant="outline" size="medium" onClick={handleComingSoon}>Newsletter Archive</Button>
        </div>
      </section>

      {/* Editorial Board Link – contained */}
      <section className={styles.editorialBoard}>
        <Card variant="elevated" className={styles.boardCard}>
          <h3>Meet the Editorial Board</h3>
          <p>The dedicated team behind the Journal of Medical Research and Practice.</p>
          <Link to="/leadership#editorial-board">
            <Button variant="primary" size="medium">View Editorial Board</Button>
          </Link>
        </Card>
      </section>
    </div>
  );
};

export default Publications;